
import * as $ from 'jquery';
import * as Responsiveness from './ui/responsiveness';

function debounce(func, timeout = 500) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

const STICKY_HEADER_OFFSET = 86;
const STICKY_BOTTOM_MARGIN = 24;

const MENU_SCROLL_OFFSET_KEY = 'subjectpage-menu-offset';

function updateMainColumnSticky(): void {
    const mainContent = document.querySelector<HTMLElement>('.subjectpage #main-content');
    if (!mainContent) {
        return;
    }

    if (Responsiveness.smallerThan(Responsiveness.TABLET_LANDSCAPE)) {
        mainContent.classList.remove('js-sticky-fit');
        return;
    }

    const available = window.innerHeight - STICKY_HEADER_OFFSET - STICKY_BOTTOM_MARGIN;
    mainContent.classList.remove('js-sticky-fit');
    mainContent.classList.toggle('js-sticky-fit', mainContent.offsetHeight <= available);
}

export function initialize(): void {
    var filterForm = document.querySelector('.subject-page-filter-form');
    var input: HTMLInputElement = filterForm?.querySelector('#document-search-field');

    $(document).ready(function () {
        const urlParams = new URLSearchParams(window.location.search);
        const query = urlParams.get('query');
        if (!query && input && input.value) {
            filter();
        }
        window.scrollTo(0, 0);
    });

    $(".menu__link.subject-menu-link").on("click", function (e) {
        let menuWrapper = $(".subjectpage .menu__wrapper");

        setTimeout(() => menuWrapper.addClass("blur"), 1000);

        const wrapperEl = menuWrapper.get(0);
        const itemEl = this.closest('.menu__item');
        if (wrapperEl && itemEl) {
            const offset = itemEl.getBoundingClientRect().top - wrapperEl.getBoundingClientRect().top;
            try {
                sessionStorage.setItem(MENU_SCROLL_OFFSET_KEY, String(offset));
            } catch (err) {
            }
        }
})
    input?.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
        }
        if (e.key !== "Tab" && e.key !== "Enter") {
            processKeyDown();
        }

    })
    function filter() {
        $(".documents").addClass("loading");
        $.get("Filter", { query: input.value, isCourse: $("#tab-Kurser").hasClass("js-active") }, function (data) {
            const newParams = new URLSearchParams({ page: "1", isCourse: $("#tab-Kurser").hasClass("js-active").toString(), query: input.value });
            window.history.replaceState({}, "", "?" + newParams.toString());
            $("#result-partial").replaceWith(data);
            $(".documents").removeClass("loading");
        });
    }

    const processKeyDown = debounce(() => filter());

    const mainContent = document.querySelector('.subjectpage #main-content');
    if (mainContent) {
        updateMainColumnSticky();

        const debouncedUpdate = debounce(updateMainColumnSticky, 150);
        window.addEventListener('resize', debouncedUpdate);
        new MutationObserver((mutations) => {
            const onlyOwnToggle = mutations.every(m =>
                m.type === 'attributes' && m.target === mainContent && m.attributeName === 'class'
            );
            if (!onlyOwnToggle) {
                debouncedUpdate();
            }
        }).observe(mainContent, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class'],
        });
    }
}

